<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" color="#0098cc" loader="dots"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {};
  },
  props: {
    isLoading: Boolean
  },
  components: {
    Loading
  }
};
</script>
